import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/movieData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex((cur) => (cur === idx ? null : idx));
  };

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="FAQ"
              title="常见问题"
              desc="把观众最常问的几个问题集中回答。点击任意问题即可展开查看详细说明。"
            />
            <div className="rounded-xl bg-background-50 border border-background-200 p-5">
              <div className="flex items-center gap-2 text-primary-600">
                <i className="ri-customer-service-2-line text-lg" />
                <span className="text-sm font-medium">找不到答案？</span>
              </div>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                若你遇到的问题不在下方列表中，可先在「播放线路」与「画质版本」分区核对网络与清晰度设置，多数卡顿与加载问题都能在那里找到处理思路。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 rounded-xl border border-background-200 bg-background-50 overflow-hidden">
              {faqs.map((item, idx) => {
                const isOpen = openIndex === idx;
                return (
                  <div key={item.q}>
                    <h3>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => toggle(idx)}
                        className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                      >
                        <span className="flex items-start gap-3">
                          <span
                            className={`mt-0.5 text-sm font-heading font-bold shrink-0 ${
                              isOpen ? "text-primary-600" : "text-foreground-400"
                            }`}
                          >
                            Q{idx + 1}
                          </span>
                          <span className="text-sm md:text-base font-medium text-foreground-950">{item.q}</span>
                        </span>
                        <i
                          className={`shrink-0 text-lg transition-transform ${
                            isOpen ? "ri-subtract-line text-primary-600 rotate-0" : "ri-add-line text-foreground-500"
                          }`}
                        />
                      </button>
                    </h3>
                    {isOpen ? (
                      <div className="px-4 md:px-5 pb-5">
                        <p className="text-sm text-foreground-600 leading-relaxed pl-0 md:pl-8">{item.a}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}